module.exports = __webpack_public_path__ + "media/images/countryrect/mz-87ccc2fc81fae3ca377745e1e20da522.svg";